<script setup lang="ts">
const userStore = useUserStore();
</script>

<template>
  <div
    v-if="userStore.notifications.unread"
    :class="userStore.notifications.unread > 99 ? 'w-6' : 'w-5'"
    class="absolute bg-primary-500 h-4 rounded-full top-0 -right-1 flex items-center justify-center">
    <span class="text-primary-600 text-xs font-semibold">{{
      userStore.notifications.unread > 99
        ? "99+"
        : userStore.notifications.unread
    }}</span>
  </div>
</template>
